/* eslint no-param-reassign: ['error', { 'props': false }] */
import helper from '@/libs/forms';


const boolFieldVisibility = (model, boolField) => {
  try {
    return model[boolField] === true;
  } catch (_) {
    return false;
  }
};


const setVisibility = (visibility, fields, ...args) => {
  fields.forEach((field) => {
    field.visible = model => visibility(model, ...args);
  });
};


const generalFields = () => [
  helper.currency('Amount', 'amount', true),
  helper.simpleInput('text', 'Institution', null, 'institution', true),
  helper.simpleInput('text', 'Account Number', null, 'accountNumber', false),
];


const otherFields = () => {
  const defaultFields = [
    helper.simpleInput('text', 'Type', null, 'type', true),
    helper.currency('Amount', 'amount', true),
    helper.checkbox('Pledged?', 'pledged'),
  ];

  const additionalFields = [
    helper.simpleInput('text', 'Name', null, 'name', true),
    helper.address('Address', null, 'address', true),
    helper.currency('Amount of Lien', 'lien', true),
    helper.simpleInput('text', 'Terms of Payment', null, 'terms', true),
    helper.boolRadio('Delinquent?', 'delinquent', true),
  ];

  const deliquency = [
    helper.simpleInput('text', 'Describe Delinquency', null, 'delinquency', true),
  ];

  setVisibility(boolFieldVisibility, additionalFields, 'pledged');
  setVisibility(boolFieldVisibility, deliquency, 'delinquent');

  return defaultFields.concat(additionalFields, deliquency);
};


export default {
  boolFieldVisibility,
  setVisibility,
  generalFields,
  otherFields,
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/financial/resources/schemaHelper.js